import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { MarkdownTracked } from "../../../../../components/markdownTracked/markdownTracked";

const MarketCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.marketHeading} id={id} />
      <MarkdownTracked
        text={briefing.marketText}
        className="text-[16px] md:text-[21px]"
        component="Market 101"
      />
    </CardContainer>
  );
};

export default MarketCard;
